import { Injectable } from '@angular/core';

import { Oauth2RessourceService } from '@app/oauth2/oauth2-resources.service';

import { Observable, from as observableFrom, of as observableOf } from 'rxjs';
import { catchError, map, mergeMap, share, tap } from 'rxjs/operators';

import { PromoContextService } from '../../../context/child/promo-context.service';
import { ContextService } from '../../../context/context.service';
import { ContextInterfaceBase } from '../context.interface';

@Injectable({
    providedIn: 'root',
})
export class AcquisitionContextServiceBase implements ContextInterfaceBase {
    public keySerialize: string = 'AcquisitionContextServiceBase';
    public contractId: string;
    public edp: boolean = false;
    public statut: string[] = ['ALL'];

    constructor(
        protected oauth2Ressource: Oauth2RessourceService,
        protected promoContextService: PromoContextService,
    ) {}

    public create(contractId: string): Observable<ContextInterfaceBase> {
        const intance: AcquisitionContextServiceBase = new AcquisitionContextServiceBase(
            this.oauth2Ressource,
            this.promoContextService,
        );
        return intance.config(contractId);
    }

    public updateContext(contextService: ContextService): Observable<ContextService> {
        return observableOf(contextService);
    }

    public serialize(): { [index: string]: any } {
        return {
            edp: this.edp,
            contractId: this.contractId,
        };
    }

    public config(contractId?: string): Observable<ContextInterfaceBase> {
        let obs: Observable<ContextInterfaceBase> = observableFrom([this]);
        if (contractId) {
            this.contractId = contractId;
            obs = obs.pipe(
                mergeMap(() =>
                    this.oauth2Ressource
                        .contracts(contractId)
                        .etalementDePaiementTerminalNu()
                        .get()
                        .pipe(
                            tap((res) => {
                                this.edp = res.items.statut;
                            }),
                            map(() => this),
                        ),
                ),
            );
        }
        return obs.pipe(
            catchError(() => observableFrom([this])),
            share(),
        );
    }
}
